/* eslint-disable no-console */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/**
 * Safe JSON.stringify that converts circular refs to `[Circular]`
 */
var stringify = function (json) {
    var cache = [];
    var result = JSON.stringify(json, function (key, value) {
        if (typeof value === 'object' && value !== null) {
            if (cache.includes(value)) {
                return '[Circular]';
            }
            cache.push(value);
        }
        return value;
    });
    cache = null;
    return result;
};
function formatError(error) {
    var result = {};
    Object.getOwnPropertyNames(error).forEach(function (key) { return (result[key] = error[key]); });
    return result;
}
function formatArg(arg) {
    if (arg instanceof Error) {
        return stringify(formatError(arg));
    }
    else if (typeof arg === 'object') {
        return stringify(arg);
    }
    return arg;
}
function toJsonString(context, args) {
    var _a = __read(args), logger = _a[0], rest = _a.slice(1);
    var result = { logger: logger, mdc: context };
    // If last arg is an error, move it under `exception` field
    var lastArg = rest.slice(-1)[0];
    if (lastArg instanceof Error) {
        rest.pop();
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'exception' does not exist on type '{ log... Remove this comment to see the full error message
        result.exception = formatError(lastArg);
    }
    // Join formatted args to form a single message string
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'message' does not exist on type '{ logge... Remove this comment to see the full error message
    result.message = rest.map(formatArg).join(' ');
    return stringify(result);
}
/**
 * A log client that writes JSON strings to console
 */
var JsonConsoleLogClient = /** @class */ (function () {
    /**
     * Create a new JsonConsoleLogClient instance
     * @param context - context map to be included in all log messages under `mdc` field
     */
    function JsonConsoleLogClient(context) {
        var _this = this;
        this.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            console.debug(toJsonString(_this.context, args));
        };
        this.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            console.info(toJsonString(_this.context, args));
        };
        this.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            console.warn(toJsonString(_this.context, args));
        };
        this.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            console.error(toJsonString(_this.context, args));
        };
        this.context = context;
    }
    /**
     * Set context
     * @param context - context map to be included in all log messages under `mdc` field
     */
    JsonConsoleLogClient.prototype.setContext = function (context) {
        this.context = context;
    };
    /**
     * Set a single context field
     */
    JsonConsoleLogClient.prototype.setContextField = function (key, value) {
        this.context[key] = value;
    };
    /**
     * Clear context map
     */
    JsonConsoleLogClient.prototype.clearContext = function () {
        this.context = undefined;
    };
    return JsonConsoleLogClient;
}());
export default JsonConsoleLogClient;
